import serviceType from 'constants/serviceType';
import axiosClient from './aixosClient';
import { AxiosResponse } from 'axios';
import { BaseResponse } from 'models/baseResponse';

export interface UsdtWithdrawalPayload {
    amount: string | number;
    address: string;
    remark?: string;
    checkpwd: string;
    flag?: string;
}

export interface AddUsdtWalletPayload {
    nname: string;
    checkpwd: string;
    wallet: string;
    network: string;
    flag?: string;
}

const usdtApi = {
    getNetworks(payload: { flag?: string } = {}): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.flag = 'getListUsdtNetwork';
        return axiosClient.post(serviceType.USDT_TRANSFER_SERVICE, payload);
    },
    getWalletAddress(payload: { providerCode?: string; flag?: string } = {}): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.providerCode = payload.providerCode || 'U8PAY';
        payload.flag = 'WalletAddress';
        return axiosClient.post(serviceType.USDT_TRANSFER_SERVICE, payload);
    },
    withdrawal(payload: UsdtWithdrawalPayload): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.flag = 'Withdrawal';
        payload.remark = payload.remark || 'USDT withdrawal';
        return axiosClient.post(serviceType.USDT_TRANSFER_SERVICE, payload);
    },
    addWallet(payload: AddUsdtWalletPayload): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.flag = 'PersonBankCardBean_addUsdtWallet';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
};

export default usdtApi;
